<template>
  <el-card shadow="never">
    <div slot="header" class="cart-header-wrapper">
      <span class="title">Customer Information</span>
      <div class="action">
        <template>
          <customize-button style="margin-right: 20px" @click="$router.go(-1)">
            Cancel
          </customize-button>
          <customize-button type="primary" @click="handleBaseInfoSave">
            Save
          </customize-button>
        </template>
      </div>
    </div>
    <customize-form
      ref="form"
      is-show-form
      :schema="infoSchema"
      :model="model"
    />
    <el-dialog
      :visible.sync="visible"
      title="Add"
      width="462px"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <div>
        <p>This customer ID already exist {{ content }} acccount</p>
      </div>
      <div slot="footer">
        <customize-button style="margin-right: 20px" @click="visible = false">
          Cancel
        </customize-button>
        <customize-button type="primary" @click="onSubmit">
          Confirm
        </customize-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import {
  addOrUpdateBaseInfo,
  getCurrencyList,
  getStateSelectList,
} from '../detail/info/basic-profile/api'
import { getSelectList } from '@/api'
import { checkCustomerName } from './api'
const selectList = [
  'Country',
  'Region',
  'CCA',
  'Business',
  'Geo',
  // 'SalesCountry',
  'BU',
]

export default {
  data() {
    return {
      visible: false,
      content: '',
      infoSchema: [
        {
          label: 'Customer #',
          key: 'code',
          type: 'Despace',
        },
        {
          label: 'Customer Name',
          type: 'input',
          key: 'name',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
        {
          label: 'Customer Type',
          type: 'select',
          key: 'customerType',
          selectList: [
            { id: 1, name: 'Trade' },
            { id: 2, name: 'Eaas' },
            { id: 3, name: 'Saas' },
          ],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
          change: this.handleCustomerTypeChange,
        },
        {
          label: 'Currency',
          type: 'select',
          placeholder: 'All',
          key: 'currency',
          selectList: [],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
        {
          label: 'Business Type',
          type: 'select',
          placeholder: 'All',
          key: 'business',
          selectList: [],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
        {
          label: 'GEO',
          type: 'select',
          placeholder: 'All',
          key: 'geo',
          selectList: [],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
          change: this.handleGeoSelectChange,
        },
        {
          label: 'Region',
          type: 'select',
          placeholder: 'All',
          key: 'region',
          selectList: [],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
          change: this.handleRegionSelectChange,
          value: '',
        },
        {
          label: 'Payment Term(Day)',
          type: 'input',
          key: 'paymentTermReq',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
        {
          label: 'Registration Country',
          type: 'select',
          placeholder: 'All',
          key: 'country',
          selectList: [],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
          change: this.handleRegistraCountry,
        },
        {
          label: 'CCA',
          type: 'select',
          placeholder: 'All',
          key: 'cca',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
          selectList: [],
        },
        {
          label: 'Sub-Region',
          type: 'input',
          key: 'subRegion',
          selectList: [],
        },
        {
          label: 'State',
          type: 'select',
          key: 'state',
          selectList: [],
          placeholder: 'All',
        },
        {
          label: 'ZIP Code',
          type: 'input',
          key: 'zipCode',
        },
        {
          label: 'Source',
          type: 'select',
          placeholder: 'All',
          disabled: true,
          value: this.$store.state.source,
          key: 'source',
          selectList: [
            { id: 1, name: 'Lenovo' },
            { id: 2, name: 'CSS' },
          ],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
        {
          label: 'City',
          type: 'input',
          key: 'city',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
        {
          label: 'Duns #',
          type: 'input',
          key: 'dunsNo',
        },
        {
          label: 'Address',
          type: 'input',
          key: 'address',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
        {
          label: 'In Business Since:(YYYY-MM-DD)',
          type: 'date',
          key: 'registerDate',
        },
        {
          label: 'Year With Lenovo Since:(YYYY-MM-DD)',
          type: 'date',
          key: 'signDate',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
        {
          label: 'Sold to #',
          type: 'input',
          key: 'soldPartyNo',
        },
        {
          label: 'National Registration # or VAT #',
          type: 'input',
          key: 'registeredNo',
        },
        {
          label: 'LINK ID',
          type: 'input',
          key: 'linkId',
        },
        {
          label: 'Phone',
          type: 'input',
          key: 'mobile',
        },
        {
          label: 'Risk Category in SAP',
          type: 'select',
          key: 'sapRiskType',
          placeholder: 'All',
          selectList: [
            {
              id: '001',
              name: '001',
            },
            {
              id: '002',
              name: '002',
            },
            {
              id: '003',
              name: '003',
            },
            {
              id: '004',
              name: '004',
            },
            {
              id: '005',
              name: '005',
            },
            {
              id: '006',
              name: '006',
            },
            {
              id: '999',
              name: '999',
            },
          ],
        },
        // {
        //   label: 'Hierarchy Level',
        //   type: 'select',
        //   key: 'hierarchyLevel',
        //   placeholder: 'All',
        //   selectList: [
        //     {
        //       id: '1',
        //       name: 'Parent',
        //     },
        //     {
        //       id: '2',
        //       name: 'Subsidiary',
        //     },
        //   ],
        // },
        {
          label: 'Sales Country',
          type: 'select',
          key: 'salesCountry',
          placeholder: 'All',
          selectList: [],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
        {
          label: 'BU',
          type: 'select',
          key: 'bu',
          placeholder: 'All',
          selectList: [],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
        {
          label: 'Channel',
          type: 'select',
          key: 'channel',
          placeholder: 'All',
          selectList: [
            {
              id: 'ECC',
              name: 'ECC',
            },
            {
              id: 'S4',
              name: 'S4',
            },
            {
              id: 'ESOT',
              name: 'ESOT',
            },
            {
              id: 'NAS4',
              name: 'NAS4',
            },
          ],
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
      ],
      model: {},
      submitData: {},
    }
  },
  created() {
    this.getAllSelect()
    this._getCurrencyList()
  },
  methods: {
    handleCustomerTypeChange(val) {
      const index = this.infoSchema.findIndex(item => item.key === 'channel')
      if ([2, 3].includes(val)) {
        this.infoSchema = this.infoSchema.map((item, i) => {
          if (i === index) {
            return {
              ...item,
              disabled: true,
              value: 'ESOT',
            }
          }
          return item
        })
        // 同时更新 model
        this.model.channel = 'ESOT'
      } else {
        this.infoSchema = this.infoSchema.map((item, i) => {
          if (i === index) {
            return {
              ...item,
              disabled: false,
              value: '',
            }
          }
          return item
        })
        this.model = {
          ...this.model,
          channel: '',
        }
      }
    },
    async handleGeoSelectChange(value, formData) {
      try {
        if (!value) {
          for (let i = 0; i < this.infoSchema.length; i++) {
            const item = this.infoSchema[i]
            if (item.label === 'Region') {
              item['selectList'] = []
            }
          }
          this.model = { ...formData }
          this.model.region = ''
          return
        }
        const res = await this._getSelectList({
          typeMark: 'Region',
          pid: value,
        })
        for (let i = 0; i < this.infoSchema.length; i++) {
          const item = this.infoSchema[i]
          if (item.label === 'Region') {
            item['selectList'] = res
          }
        }
        this.model = { ...formData }
        this.model.region = ''
      } catch (err) {
        console.error(err)
      }
    },
    async handleRegionSelectChange(value, formData) {
      try {
        // 当region == OEM时，不联动，显示所有国家  OEM的value为1434758713631649794
        const regionOEM = [
          '1396671261928956221',
          '1485507981976072193',
          '1485507838971277313',
          '1485504000834990081',
          '1485508292971130882',
          '1485508065744711682',
        ]
        if (regionOEM.includes(value)) {
          const res1 = await this._getSelectList({
            typeMark: 'Country',
          })
          for (let i = 0; i < this.infoSchema.length; i++) {
            const item = this.infoSchema[i]
            if (item.label === 'Sales Country') {
              item['selectList'] = res1
            }
          }
        } else {
          if (!value) {
            for (let i = 0; i < this.infoSchema.length; i++) {
              const item = this.infoSchema[i]
              if (item.label === 'Sales Country') {
                item['selectList'] = []
              }
            }
            this.model = { ...formData }
            this.model.salesCountry = ''
            return
          }
          const res = await this._getSelectList({
            typeMark: 'Country',
            pid: value,
          })
          for (let i = 0; i < this.infoSchema.length; i++) {
            const item = this.infoSchema[i]
            if (item.label === 'Sales Country') {
              item['selectList'] = res
            }
          }
        }
        this.model = { ...formData }

        // 添加一个条件判断，如果为日本，自动选择
        if (value === '1396671261948956118') {
          this.model.salesCountry = '1434758103312457'
        } else {
          this.model.salesCountry = ''
        }
      } catch (err) {
        console.error(err)
      }
    },
    async _getCurrencyList() {
      try {
        const data = await getCurrencyList()
        for (let i = 0; i < this.infoSchema.length; i++) {
          const item = this.infoSchema[i]
          if (item.label === 'Currency') {
            item['selectList'] = data.map(item => ({
              name: item.currencyName,
              id: item.currency,
            }))
          }
        }
      } catch (err) {
        console.error(err)
      }
    },
    getAllSelect() {
      const pro = selectList.map(item => this._getSelectList(item))
      Promise.all(pro)
        .then(res => {
          if (res.length === selectList.length) {
            const [
              countryList,
              regionList,
              ccaList,
              businessList,
              geoList,
              BuList,
            ] = res
            // 基本信息
            for (let i = 0; i < this.infoSchema.length; i++) {
              const item = this.infoSchema[i]
              if (item.label === 'Region') {
                item['selectList'] = []
              } else if (item.label === 'Registration Country') {
                item['selectList'] = countryList
              } else if (item.label === 'CCA') {
                item['selectList'] = ccaList
              } else if (item.label === 'Business Type') {
                item['selectList'] = businessList
              } else if (item.label === 'GEO') {
                item['selectList'] = geoList
              } else if (item.key === 'salesCountry') {
                item['selectList'] = []
              } else if (item.key === 'bu') {
                item['selectList'] = BuList
              }
            }

            this.isAllLoad = false
          }
        })
        .catch(err => {
          console.error(`search 列表查询错误:${err}`)
        })
    },
    async _getSelectList(typeMark) {
      try {
        return await getSelectList(typeMark)
      } catch (err) {
        console.error(err)
      }
    },
    // 点击添加按钮
    async handleBaseInfoSave() {
      try {
        const { form } = this.$refs
        const valid = await form.validateFields()
        if (valid) {
          const params = form.getFormData()

          params.code = params.code.replace(/[ ]/g, '')

          this.submitData = params

          if (params.code) {
            const res = await checkCustomerName({ code: params.code })
            if (res.length > 0) {
              this.content = Array.isArray(res) ? res.join(' & ') : res
              this.visible = true
              return
            }
          }

          this.onSubmit()
        }
      } catch (err) {
        console.log(err)
      }
    },
    async onSubmit() {
      const data = await addOrUpdateBaseInfo(this.submitData)
      if (data.name === 2) {
        this.$message.warning('The customer name already exists')
      }
      this.timer = setTimeout(() => {
        this.$message.success('success')
        this.$router.go(-1)
      }, 1000)
    },
    async handleRegistraCountry(value) {
      if (value === '14347581033124127' || value === '1613372802212085762') {
        value = '1'
      }
      const res = await getStateSelectList(value)
      for (let i = 0; i < this.infoSchema.length; i++) {
        const item = this.infoSchema[i]
        if (res.length) {
          if (item.label === 'State') {
            item['placeholder'] = 'All'
          }
        } else {
          if (item.label === 'State') {
            item['placeholder'] = 'NA'
          }
        }
        if (item.label === 'State') {
          item['selectList'] = res.map(item => ({
            id: item.state,
            name: item.state,
            value: item.state,
          }))
        }
      }
    },
  },
}
</script>
